import { useEffect, useState } from 'react'
import { isUserLoggedInVar } from '../graphql/stores/local'
import { getUserVar } from '../graphql/stores/user'

/**
 *
 * @returns {{authenticate: function, authenticatedUser: Object, signout: function, isAuthenticated: boolean, token: string}}
 */
export const useAuthenticated = () => {
  const localStorageValue = JSON.parse(localStorage.getItem('isAuthenticated'))
  const defaultValueFromLocalStorage = localStorageValue ? localStorageValue : false
  const [isAuthenticated, setAuthenticated] = useState(defaultValueFromLocalStorage)
  const [token, updateToken] = useState(localStorage.getItem('token'))
  const [authToken, setAuthToken] = useState(localStorage.getItem('authToken'))
  // const [authenticatedUser, setAuthenticatedUser] = useState({})
  useEffect(() => {
    isUserLoggedInVar(isAuthenticated)
  }, [isAuthenticated])

  /**
   *
   * @param authenticatedUser
   * @param token
   */
  const authenticate = ({ token, authToken, authenticatedUser }) => {
    // setAuthenticatedUser(authenticatedUser)
    updateToken(token)
    setAuthToken(null)
    setAuthenticated(true)
    isUserLoggedInVar(true)
    getUserVar(authenticatedUser)
    localStorage.setItem('isAuthenticated', 'true')
    localStorage.setItem('token', token)
    localStorage.setItem('authToken', authToken)
    localStorage.setItem('authenticatedUser', JSON.stringify(authenticatedUser))
  }

  const signOut = () => {
    // setAuthenticatedUser({})
    updateToken(null)
    setAuthenticated(false)
    isUserLoggedInVar(false)
    getUserVar({})
    localStorage.clear()
  }

  return { isAuthenticated, token, authenticate, signOut, authToken }
}

export default useAuthenticated
